export function getStatusLabel(status) {
  if (!status) return 'Not Started';
  if (typeof status === 'object') return status.name || status.label || 'Not Started';
  if (status === 'ON_TRACK') return 'On Track';
  return status;
}
